// <head> metadata for SolutionsPliablePage (https://www.dbos.dev/solutions/pliable).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Durable Data Pipeline Platform for Pliable',
    },
    {
      name: 'description',
      content:
        'Integrate Pliable data cleansing and data preparation into your durable data engineering pipelines on DBOS.',
    },
    {
      property: 'og:title',
      content: 'Durable Data Pipeline Platform for Pliable',
    },
    {
      property: 'og:description',
      content:
        'Integrate Pliable data cleansing and data preparation into your durable data engineering pipelines on DBOS.',
    },
    {
      property: 'og:image',
      content: 'https://www.dbos.dev/assets/images/677b772d7002e0353e5307b2_DBOS-Durable-Data-Pipeline-Platform.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Durable Data Pipeline Platform for Pliable',
    },
    {
      name: 'twitter:description',
      content:
        'Integrate Pliable data cleansing and data preparation into your durable data engineering pipelines on DBOS.',
    },
    {
      name: 'twitter:image',
      content: 'https://www.dbos.dev/assets/images/677b772d7002e0353e5307b2_DBOS-Durable-Data-Pipeline-Platform.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/solutions/pliable',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
